import React from 'react';
import { IconStar, IconStarFilled } from '@tabler/icons-react';

/**
 * Scoring Panel Component
 * Handles star ratings only
 */
const ScoringPanel = ({
  scores,
  ratingFields,
  onScoreUpdate
}) => {
  // Handle rating change
  const handleRatingChange = (field, value) => {
    onScoreUpdate(field, value);
  };

  return (
    <div>
      {/* Star Ratings with better spacing */}
      <div className="grid grid-cols-1 gap-3">
        {ratingFields.map((field) => (
          <div key={field.key} className="flex items-center justify-between">
            <p className="text-[0.813rem] font-medium text-text-primary">
              {field.label}
            </p>
            <div className="flex gap-0.5">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  onClick={() => handleRatingChange(field.key, star)}
                  className="p-1 min-h-[44px] min-w-[32px] sm:p-0 sm:min-h-0 sm:min-w-0 flex items-center justify-center text-text-tertiary hover:text-accent"
                >
                  {star <= (scores[field.key] || 0) ? (
                    <IconStarFilled size={18} className="text-accent" />
                  ) : (
                    <IconStar size={18} />
                  )}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScoringPanel;
